import { useState } from 'react';
import { ACCESS_QUESTION, checkAccess } from '../access.js';
import { Logo } from './Logo.js';

export function Login({
  initialName,
  onEnter,
}: {
  initialName: string;
  /**
   * Cevap da yukarı taşınıyor: online masaya bağlanırken sunucuya ORTAK
   * PAROLA olarak gidiyor. İstemcideki kapı tek başına kapı değil — sunucu
   * da aynı cevabı soruyor.
   */
  onEnter(name: string, answer: string): void;
}) {
  const [name, setName] = useState(initialName);
  const [answer, setAnswer] = useState('');
  const [error, setError] = useState('');

  const submit = () => {
    const trimmed = name.trim();
    if (!trimmed) {
      setError('Adını yaz');
      return;
    }
    if (!checkAccess(answer)) {
      setError('Olmadı');
      return;
    }
    onEnter(trimmed, answer.trim());
  };

  return (
    <div className="home">
      <Logo />
      <h1>Üç Beş Sekiz</h1>

      <form
        className="login__form"
        onSubmit={(e) => {
          e.preventDefault();
          submit();
        }}
      >
        <label className="field">
          <span>Adın</span>
          <input
            value={name}
            onChange={(e) => setName(e.target.value.slice(0, 16))}
            placeholder="Oyuncu"
            autoComplete="off"
            autoCapitalize="words"
          />
        </label>

        <label className="field">
          <span>{ACCESS_QUESTION}</span>
          <input
            value={answer}
            onChange={(e) => setAnswer(e.target.value.slice(0, 16))}
            // Sayı klavyesi açılıyor ama tip `text`: baştaki sıfır korunsun.
            inputMode="numeric"
            autoComplete="off"
          />
        </label>

        <p className="login__error">{error}</p>

        <button type="submit" className="btn btn--primary btn--pill btn--big">
          Gir
        </button>
      </form>
    </div>
  );
}
